import { Routes, Route } from 'react-router-dom';
import PartnerLogin from './pages/PartnerLogin';
import PartnerDashboard from './pages/PartnerDashboard';
import PartnerRegistration from './pages/PartnerRegistration';

const PartnerModule = () => {
  return (
    <Routes>
      <Route path="/" element={<PartnerLogin />} />
      <Route path="login" element={<PartnerLogin />} />
      <Route path="register" element={<PartnerRegistration />} />
      <Route path="dashboard" element={<PartnerDashboard />} />
    </Routes>
  );
};

export default PartnerModule;